<script>
import { defineComponent } from "vue";
import PdfSlot from "../PdfSlot/PdfSlot.vue";
import html2pdf from 'html2pdf.js';
const name = 'PdfCartaPropostaSemComponentes'

export default defineComponent({
  name,

  components: { PdfSlot }, 
  emits:['isLoading'],
  props: { 
    cartaPropostaId:{
      type: String,
      default: ""
    },
    nomeClientePersonalizado:{
      type: String,
      default: ""
    },
    canDownloadPdf:{
      type: Boolean,
      default: false
    },

    openPdfNewTab:{
      type: Boolean,
      default: true,
    } 


  },

  mounted () { 
    //CARTA SINTETICA
    this.getPdfData().then(()=>this.canRender = true)
  },

  updated () { },

  data () {
    return { 
      arrayOrcamentosInformacoes: [],
      nomeCliente:"",
      cnpjCliente:"",
      codigoCliente:"",
      nomeRepresentante:"",
      canRender: false,
      valorIpi : 0,
      valorIcms : 0,
      valorPisCofinsFormatado:"",
      formaPagamento: "",
      nomeEmpresa:"",
      codigoCartaProposta:"", 

    }
  },

  methods: {
    async getPdfData(){
      this.$emit('isLoading',true)
      await this.getResumoFinalCartaProposta()
      await this.getPorcentagensImpostos()
      this.$emit('isLoading',false)
    },

    async getResumoFinalCartaProposta() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetResumoFinalCartaProposta/${this.cartaPropostaId}`,
      })
      .then((response) => {
        const info= response.data.data
        this.codigoCliente = info.codigoCliente;
        this.nomeCliente = info.nomeCliente;
        this.cnpjCliente = info.cnpjClienteFormatado;
        this.nomeRepresentante = info.nomeRepresentante;
        this.arrayOrcamentosInformacoes =  info.orcamentosInformacoes 
        this.formaPagamento = info.formaDePagamento
        this.nomeEmpresa = info.nomeEmpresa
        this.codigoCartaProposta = `#${info.codigoCarta}` 
      })
      .catch(() => {
      })      
    },

    async getPorcentagensImpostos() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetPorcentagensImpostos/${this.cartaPropostaId}`,
      })
      .then((response) => {
        this.valorIpi = response.data.data.porcentagemIpi
        this.valorIcms = response.data.data.porcentagemIcms
        this.valorPisCofinsFormatado = response.data.data.porcentagemPisCofinsFormatado   
        
        
      })
      .catch(() => {
      });
    },

    createImageHeaderFooter(imgHref) {
      const img = document.createElement("img");	
      img.src = imgHref;
      img.style.border="none"
      return img
    },

    pdfCallback(el, pdfConfig){
      const pdf = el;

      // Configuração atualizada para html2pdf com margens otimizadas
      const config = {
        ...(pdfConfig || {}), // Mantém configurações originais
        
        // Configuração de quebra de página com margens explícitas
        margin: [28, 10, 15, 10], // Margens [topo, direita, inferior, esquerda] em mm - laterais reduzidas
        jsPDF: {
          unit: 'mm', // Crucial para consistência
          format: 'a4',
          orientation: 'portrait',
          ...(pdfConfig && pdfConfig.jsPDF ? pdfConfig.jsPDF : {}) // Mantém outras configs jsPDF
        },
        image: { type: 'jpeg', quality: 0.98, useCORS: true, ...(pdfConfig && pdfConfig.image) },
        html2canvas: { scale: 4, useCORS: true, ...(pdfConfig && pdfConfig.html2canvas) }
      };
      
      const headerImage = new URL("@/assets/imgs/Cabecalho_PDF_CartaProposta_PNG.png", import.meta.url)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      
      const headerImageFirstPage = new URL("@/assets/imgs/Cabecalho_Carta_Proposta_1_PNG.png", import.meta.url)
      const headerImageFirstPagePdf = this.createImageHeaderFooter(headerImageFirstPage.href)
      
      const footerImageLastPage = new URL("@/assets/imgs/Rodape_Orcamento_inicio_PNG.png", import.meta.url)
      const footerImageLastPagePdf = this.createImageHeaderFooter(footerImageLastPage.href)
      
      const footerImage = new URL("@/assets/imgs/Rodape_CartaProposta_PNG.png", import.meta.url)
      const footerPdf = this.createImageHeaderFooter(footerImage.href)
		
      const altura = 4.5;
      const headerSecundario = 3;
      const footer = -5.5;

      html2pdf().from(pdf).set(config).toPdf().get('pdf')
      .then( (pdf) => {
        try{
          var totalPages = pdf.internal.getNumberOfPages();
          
          
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            if(i === 1){
              pdf.addImage(headerImageFirstPagePdf, 'Image-HTMLElement ', 0, altura + 0, 210, 0 );
              if(this.nomeEmpresa.includes('NORDESTE')){
              pdf.setTextColor("#3f3f3f");
              pdf.setFontSize(12);
              pdf.setFont('Helvetica','normal');
              pdf.text("Carta-Proposta",153,altura + 10)
              pdf.setFont('Helvetica','bold');
              pdf.text(this.codigoCartaProposta,183,altura + 10)						
              pdf.setLineWidth(0.5);
              pdf.setDrawColor("#4f2c19");
              pdf.line(180, altura + 16, 200, altura + 16);
              pdf.setFont('Helvetica','bold');
              pdf.setFontSize(11.5);
              pdf.text(this.nomeEmpresa,124,altura + 24)		
              }		
              else{
              pdf.setTextColor("#3f3f3f");
              pdf.setFontSize(12);
              pdf.setFont('Helvetica','normal');
              pdf.text("Carta-Proposta",150,altura + 10)
              pdf.setFont('Helvetica','bold');
              pdf.text(this.codigoCartaProposta,180,altura + 10)						
              pdf.setLineWidth(0.5);
              pdf.setDrawColor("#4f2c19");
              pdf.line(180, altura + 16,  200, altura + 16);
              pdf.setFont('Helvetica','bold');
              pdf.setFontSize(13);
              pdf.text(this.nomeEmpresa,145, altura + 24)		
              }						

            }else{
              pdf.addImage(headerPdf, 'Image-HTMLElement ', 0, headerSecundario + 0, 210, 0 );
            }
            if(i < totalPages){
              pdf.addImage(footerPdf, 'Image-HTMLElement', 0,footer + pdf.internal.pageSize.getWidth() + 79.2, 210, 0);

              pdf.setTextColor("#FFF");
              pdf.setFontSize(10);
              pdf.setFont('Helvetica','bold');
              pdf.text(this.diaHojeFormatado,168,footer + 294)

            }else{
              pdf.addImage(footerImageLastPagePdf, 'Image-HTMLElement', 0, footer + pdf.internal.pageSize.getWidth()+71, 210, 0);

              pdf.setTextColor("#572d0c");
              pdf.setFontSize(10);
              pdf.setFont('Helvetica','bold');
              pdf.text(this.diaHojeFormatado,170, footer +294)
            }
           
          } 
        }
        catch (e) {
          console.error(e)
        }
        if(this.canDownloadPdf){
          pdf.save('CartaProposta_' + this.codigoCartaProposta + '_' + this.nomeCliente + '.pdf')
        }
        if(this.openPdfNewTab){
          window.open(pdf.output('bloburl'), '_blank')
        }
      })
    
    }

   },

   computed: { 
    diaHojeFormatado(){
      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        let today = new Date();
        return  today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
    },

    orcamentoQuantidadeMostrar(){
      return this.arrayOrcamentosInformacoes
        .map(m=>m.orcamentoDatas
          .map(mq=> {
            const orcamentoQuantidade = {
              nomeProduto:m.nomeProduto,
              codigoOrcamento : m.codigoOrcamento,
              quantidadeFormatada : mq.quantidadeFormatada,
              indicadorDeTipoFreteoEnum : m.informacaoFrete,
              valorPrecoIdealFormatado : mq.valorPrecoIdealFormatado,
              informacaoFrete: mq.informacaoFrete
            }
            return orcamentoQuantidade
          })
        ).flat()
    },

    codigoObsOrcamentoArray(){
      return this.arrayOrcamentosInformacoes.filter(f=>f.observacaoProduto).map(m=>{
        return {
          codigoOrcamento:m.codigoOrcamento,
          observacaoProduto:m.observacaoProduto
        }
      })
    },

    obsGeralNegociacaoArray(){
      const temp =  [...new Set(this.arrayOrcamentosInformacoes.map(m=>{
        const item = {
          observacaoGeral:m.observacaoGeral,
          observacaoNegociacao:m.observacaoNegociacao
        }

        return JSON.stringify(item)
      }))]
      
      
      
      return temp.map(m=>JSON.parse(m))
    }
  }, 

});
</script>

<template>  
    <PdfSlot  v-if="canRender" :pdfCallback="pdfCallback">
      <div class="pdf-content">
        <div class="section-container">
          <table class="table-titulo">
            <tr>
              <td><h2 style="margin-top:.8em">{{codigoCliente}}</h2></td>
              <td>
                <div class="titulo"> À {{ nomeCliente }}</div>
                <div class="titulo">CNPJ. {{cnpjCliente}}</div>
              </td>
            </tr>
          </table>
        </div>
        <p v-if="nomeClientePersonalizado"><em class="pronome-tratamento">A/Sr(a):</em> {{ ' '+nomeClientePersonalizado }} </p>
        <p> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </p>
        
        <div class="orcamento-container section-container">
          <header>
            <h4>Orçamento</h4>
            <h4>REF</h4>
            <h4>Quantidade</h4>
            <h4>Preço Unitário</h4>
            <h4>Frete</h4>
          </header>

          <table>
            <tr v-for="quantidade,index in orcamentoQuantidadeMostrar" 
              class="orcamento-quantidade-item linha-quantidade"  
              :class="{'linha-quantidade-bg-2': index%2 === 1}"
              :key="index"
            >
              <p>{{quantidade.codigoOrcamento}}</p> 
              <p>{{quantidade.nomeProduto }}</p> 
              <p>{{quantidade.quantidadeFormatada}}</p>
              <p>{{ `R$ ${quantidade.valorPrecoIdealFormatado}` }}</p>
              <p>{{quantidade.indicadorDeTipoFreteoEnum}}</p>
            </tr>
          </table>
        </div>
              
        <section class="validate-pagamento section-container">
          <!-- <img src="@/assets/imgs/Icone_Agenda.svg" class="validade-pagamento-img"> -->
          <div class="validade-pagamento-item">
            <h3>VALIDADE DA PROPOSTA:</h3>
            <p>10 DIAS</p>
          </div>
        </section>

        <section class="validate-pagamento section-container">
          <!-- <img src="@/assets/imgs/Icone_Condicoes_Pagto.svg" class="validade-pagamento-img"> -->
          <div class="validade-pagamento-item">
            <h3>CONDIÇÕES DE PAGAMENTO</h3>
            <p>{{ formaPagamento }}</p>
          </div>
        </section>

        <section class="tributacao section-container">
          <h3>Tributações*</h3>
          <div class="icms-pis-ipi">
            <div class="tributacao-item">
              <em>ICMS</em>
              <p>{{ this.valorIcms !== 0 ? 'Incluso - '+ this.valorIcms + '%' : 'Diferido'}}</p>

            </div>
            <div class="tributacao-item">
              <em>PIS / COFINS </em>  
              <p>{{ this.valorPisCofinsFormatado  ? 'Incluso - '+ this.valorPisCofinsFormatado + '%' : 'Diferido'}}</p>
            </div>
            
            <div class="tributacao-item">
              <em>IPI</em>
              <p>{{ this.valorIpi == 0 ? 'Não Incluso - Preço acima + IPI' : 'Diferido'}}</p>
            </div>
          </div>
        </section>


        <section v-if="obsGeralNegociacaoArray.length > 0" class="section-container">
            <h2> OBSERVAÇÕES DA NEGOCIAÇÃO </h2>
            <p> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </p>   
            <p>  - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos.</p>
            <div v-for="obs,indexObs in obsGeralNegociacaoArray" :key="indexObs">
              <p v-if="obs.observacaoGeral" >{{ '- '+obs.observacaoGeral }}</p>
              <p v-if="obs.observacaoNegociacao">{{ '- '+ obs.observacaoNegociacao}}</p>
            </div>
            
          </section>

        <section class="finalizacao section-container">
          <h3>Representante :<em>{{ ' '+nomeRepresentante }}</em></h3>
          
          <p><em>Sem mais para o momento,<br></em>Nos colocamos a vosso dispor</p>
        </section>
      </div>
    </PdfSlot> 
</template>


<style scoped>
.pdf-content{
  font-family: 'MontSerrat';
  padding-top: 64px;
  
}

table{
  width: 100%;
  height: auto;
  border: none;
}

.table-titulo{
  width: fit-content;
  border-spacing: 16px;
}

.pdf-content > * {
  margin-bottom: 8px;
}

.pdf-content p{
  color: #8a8a8a;
}

.pdf-content h1,.pdf-content h2,.pdf-content h3{
  color: #4f2c19;
  text-align: left;
  font-weight: 700;
  letter-spacing: 1px;
}

.pdf-content ul{
  list-style: none;
}




.pronome-tratamento{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
}

.orcamento-container header,.linha-quantidade{  
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1.2fr .8fr 1fr .8fr;
  align-items: center;
  justify-items: center;
  width: 100%;
  padding: 7px;
  
}

.orcamento-container header h4{
  color: #3f3f3f;

}

.orcamento-quantidade-item p {
  word-break: break-all;
}

/* Prevent word breaking in the Nome do Produto column (2nd column) */
.orcamento-quantidade-item p:nth-child(2) {
  word-break: keep-all; /* Evita quebra no meio da palavra */
}

/* Prevent word breaking in the Frete column (5th column) */
.orcamento-quantidade-item p:nth-child(5) {
  word-break: keep-all;
}

.linha-quantidade-bg-2{
  background-color: white !important;
}


/* Classe para seções que podem ter quebra antes, mas não internamente */
.section-container {
  width: 100%;
  margin-bottom: 16px;
}


h1,h2,h3,p,li,ul,ol,figure{
  margin: 0;
  padding: 0;
}

p{
  font-size: 12px;
}

h2{
  font-size: 14px;
}

h3{
  font-size: 12px;
}

h4{
  font-size: 15px;
}

h3 em {
  color: #8a8a8a;
  font-style: normal;
  font-weight: normal;
}

h2:after{
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background-color: #fcb315;
  margin-top: 8px;
  margin-bottom: 8px;
}


.orcamento-quantidade-item{
  width: 100%;
  margin: 0 auto;
  height: 100%;
  background-color: #e3e3e3;
  text-align:center;
}



.validate-pagamento{
  background-color: #f9f9f9;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: flex;
  gap: 16px;
}

.validade-pagamento-item{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;

}

.validate-pagamento h3{
  color: #4f2c19 ;
}

.tributacao{
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f9f9f9;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  font-size: 13px;
}

.tributacao-item{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}
.tributacao-item em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
    font-size: 12px;
  
}

.icms-pis-ipi{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 16px;

}

.finalizacao em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;

}

.finalizacao{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.titulo{
  color: #4f2c19;
  text-align: left;
  font-weight: 700;
  letter-spacing: 1px;
   font-size: 14px;
}
</style>
